import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch } from "react-redux";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { AiFillBank } from "react-icons/ai";
import { BsCurrencyEuro } from "react-icons/bs";
import { FcContacts, FcDepartment, FcOk } from "react-icons/fc";

import classes from "./Account.module.css";
import { getMe } from "../../api/api";
import { alertActions } from "../../store/alert-slice";
import { formatCurrency } from "../../util/utility";
import { currencySymbol } from "../../util/config";

const Account = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState([1]);
  const { jwt } = useCookies(["jwt"])[0];
  const dispatch = useDispatch();

  useEffect(() => {
    const request = async () => {
      const res = await getMe(jwt);
      if (res.status === "success") {
        setUser(res.data.user);
        setIsLoading(false);
      } else {
        dispatch(
          alertActions.setState({ message: res.message, status: "error" })
        );
      }
      setTimeout(() => {
        dispatch(alertActions.resetState());
      }, 3000);
    };
    request();
  }, [jwt, dispatch]);

  const active = user.active ? "Active" : "Blocked";
  const balance = formatCurrency(user.balance);
  return (
    <section className={classes.account}>
      <header className={classes.pageHead}>
        <p className={classes.eyebrow}>Account overview</p>
        <h1 className={classes.pageTitle}>
          <HiOutlineUserCircle className={classes.pageTitleIcon} aria-hidden />
          Your details
        </h1>
      </header>
      <div className={classes.info}>
        {isLoading && (
          <Skeleton
            count={5}
            variant="rectangular"
            className={classes.skeleton}
          />
        )}

        {!isLoading && (
          <div className={classes.infos}>
            <span>
              <FcContacts className={classes.icon} /> Account Name
            </span>
            <span>{user.name}</span>
          </div>
        )}
        {!isLoading && (
          <div className={classes.infos}>
            <span>
              <AiFillBank className={classes.icon} /> Account Type
            </span>
            <span>Offshore Savings Account</span>
          </div>
        )}
        {!isLoading && (
          <div className={classes.infos}>
            <span>
              <FcDepartment className={classes.icon} /> Account number
            </span>
            <span>{user.accountNumber}</span>
          </div>
        )}
        {!isLoading && (
          <div className={classes.infos}>
            <span>
              <BsCurrencyEuro className={classes.icon} /> Account Balance
            </span>
            <span>{currencySymbol}{balance}</span>
          </div>
        )}
        {!isLoading && (
          <div className={classes.infos}>
            <span>
              <FcOk className={classes.icon} /> Account Status
            </span>
            <span>{active}</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default Account;
